<template>
  <div class="relative">

    <div v-if="condicion_de_rutas" class="top-0 w-full bg-black md:bg-black left-0 absolute" style="height: 5px">
      <div class="bg-white h-full" id="loading-bar" style="width: 0%"></div>
    </div>

    <div v-if="condicion_de_rutas"
      class="bg-black justify-evenly items-center px-3 md:justify-center md:gap-6 transition-all duration-700 ease-in hidden md:flex">
      <ul
        class="list-none flex flex-row justify-center text-[12px] items-center w-full py-[3px] overflow-hidden overflow-x-auto whitespace-nowrap [&>li]:mx-3 [&>li:first-child]:ms-0 md:[&>li]:mx-0 [&>li>a]:p-[15px] font-sans tracking-[1px]">
        <li>
          <a href="/blog" class="text-white transition block">Blog</a>
        </li>
        <li>
          <a href="/revision-tecnica" class="text-white transition block">Calendario Revisión Técnica</a>
        </li>
        <li>
          <a href="https://qr.queop.com/a4391284c0d2cbbe4c17f70526c4dc0d1"
            class="text-white transition block">Sugerencias y Reclamos</a>
        </li>
        <li>
          <a href="/boletas" class="text-white transition block">Consulta Boletas</a>
        </li>
        <li>
          <a @click="navigateToTerminos" class="text-white transition block cursor-pointer">
            Términos y Condiciones
          </a>
        </li>
        <li>
          <NuxtLink to="/postulaciones" class="forzarpadding text-white bg-ROJO_LEON rounded-lg transition block">
            Trabaja con nosotros
          </NuxtLink>
        </li>
      </ul>
    </div>

    <!-- Barra roja comun -->
    <header class="relative">
      <div id="sticky-header" class="bg-ROJO_LEON w-full tracking-[1px]">
        <div class="flex flex-row items-center font-sans py-3 w-[86%] md:w-[92%] justify-self-center justify-between gap-2 md:gap-0">
          <!--Boton logo-->
          <button @click="navigateToHome"
            aria-label="Ir al inicio"
            class="h-auto w-auto hover:bg-[#8B1A17] rounded transition-all duration-300 py-2">
            <img class="h-10 max-h-[39px] ml-[4px]" :src="logoUrl" alt="logo-leon" />
          </button>

          <div class="flex items-center">
            <!--Servicos y enlaces-->
            <div v-if="condicion_de_rutas" class="md:flex items-center uppercase text-1xs [&>div]:py-0 gap-2 pr-4">
              <div class="hidden md:block">
                <a class="flex md:flex-row items-center gap-3 text-white productos-button cursor-pointer menu-link"
                  @click="showMenuProducts = !showMenuProducts">
                  <img class="h-[1.3rem] w-auto" src="/img/newhome/header/directions_car.svg" />
                  Productos y Servicios
                  <img src="/img/newhome/header/white-arrow.webp" class="transition-all"
                    :class="{ 'rotate-180': showMenuProducts }" />
                </a>
              </div>
              <div class="hidden md:block">
                <a @click="navigateToNuestrosLocales"
                  class="hidden md:flex md:flex-row items-center gap-3 text-white menu-link">
                  <img class="h-[1.3rem] w-auto" src="/img/newhome/header/storefront.svg" />Nuestros Locales
                </a>
              </div>
              <div class="hidden md:block">
                <a @click="navigateToBeneficios" class="hidden md:flex md:flex-row items-center gap-3 text-white menu-link">
                  <img class="h-[1.3rem] w-auto" src="/img/newhome/header/redeem.svg" />
                  Beneficios
                </a>
              </div>
              <div class="hidden md:block">
                <a @click="navigateToRetiraYEntrega"
                  class="hidden md:flex md:flex-row items-center gap-3 text-white menu-link">
                  <img class="h-[1.3rem] w-auto" :src="`/img/newhome/header/delivery_truck_bolt.svg`" />
                  Retiro y Entrega
                </a>
              </div>
              <div class="hidden md:block">
                <a
                  @click="navigateToAsociados"
                  class="hidden md:flex md:flex-row items-center gap-3 text-white menu-link cursor-pointer"
                >
                  <img class="h-[1.3rem] w-auto" src="/img/newhome/header/location_away.svg" />Asociados LEÓN
                </a>

              </div>
            </div>

            <!--boton llamanos-->
            <div>
              <button @click="openTelephonellamanosv2"
                class="bg-VERDE_TOP_CALIDAD hover:bg-BLANCO_LEON hover:modificar hover:text-VERDE_TOP_CALIDAD font-bold transition py-1 px-5 rounded-md text-white hidden md:flex justify-center items-center call-button gap-1">
                <span class="text-[12px]">Llámanos</span>
                <img :src="'/img/home/tel_boton.svg'" alt="phone-icon" class="phone-icon-submenu transition" />
              </button>
            </div>

            <!--contenedor de carritos o boton apertura menu mobil-->
            <div class="flex gap-5 md:gap-8 items-center ml-0 md:ml-5">

              <div class="relative" v-if="carrito_neumaticos">
                <NuxtLink to="/neumaticos/carro" class="flex flex-row w-auto hover:cursor-pointer"
                  @click="resetShoppingStep">
                  <img :src="'/img/dc_img/carroNeumaticos.svg'" class="h-[2.4rem] w-[2.4rem] mr-[0.2rem]" alt="" />
                  <span class="absolute bg-BLANCO_LEON rounded-full font-bold text-xs flex items-center justify-center border-2 border-red-500"
                    style="width: 26px; height: 26px; top: -4px; right: -16px; padding: 0px !important">{{ countCart }}
                  </span>
                </NuxtLink>
              </div>

              <div class="relative" v-if="carrito_baterias">
                <NuxtLink to="/baterias/carro" class="flex flex-row w-auto hover:cursor-pointer"
                  @click="resetShoppingStep">
                  <img :src="'/img/dc_img/carroBaterias.svg'" class="h-[2.4rem] w-[2.4rem] mr-[0.2rem]" alt="" />
                  <span class="absolute bg-BLANCO_LEON rounded-full font-bold text-xs flex items-center justify-center border-2 border-red-500"
                    style="width: 26px; height: 26px; top: -4px; right: -16px; padding: 0px !important">{{ countCart }}
                  </span>
                </NuxtLink>
              </div>

              <button @click="showMenuMobile = !showMenuMobile" id="header-menu-hamburger"
                class="flex gap-[3px] flex-col md:hidden">
                <div class="py-[2px] bg-white w-[30px]"></div>
                <div class="py-[2px] bg-white w-[30px]"></div>
                <div class="py-[2px] bg-white w-[30px]"></div>
              </button>
            </div>

          </div>

        </div>
      </div>

      <!--contenedor del menu de mobile una vez se presione el boton de apertura-->
      <div class="bg-white fixed top-0 w-full z-[250] h-screen overflow-y-auto md:hidden transition-all p-3 flex flex-col gap-10"
        :class="{ 'left-0': showMenuMobile, 'left-full': !showMenuMobile }">
        <div class="flex justify-between items-center">
          <img src="/img/newhome/header/leon-rojo.webp" class="md:hidden" />
          <div class="md:hidden bg-ROJO_LEON rounded-full py-3 px-2 cursor-pointer transition"
            @click="showMenuMobile = !showMenuMobile">
            <div class="bg-white h-1 w-4 rotate-45 relative top-[2px]"></div>
            <div class="bg-white h-1 w-4 -rotate-45 relative -top-[2px]"></div>
          </div>
        </div>
        <div class="flex flex-col gap-3">
          <div class="rounded-lg flex items-center p-3 gap-3 bg-GRIS_CLARO font-semibold relative"
            @click="showMenuProducts = !showMenuProducts">
            <img src="/img/newhome/header/directions_car.svg" class="brightness-0" />Productos y Servicios <img
              src="/img/newhome/header/white-arrow.webp"
              class="-rotate-90 brightness-0 absolute top-1/2 -translate-y-1/2 right-3" />
          </div>
          <a @click="navigateToNuestrosLocales"
            class="rounded-lg flex items-center p-3 gap-3 bg-GRIS_CLARO font-semibold relative">
            <img src="/img/newhome/header/storefront.svg" class="brightness-0" />Nuestros Locales
          </a>
          <a @click="navigateToBeneficios"
            class="rounded-lg flex items-center p-3 gap-3 bg-GRIS_CLARO font-semibold relative">
            <img :src="`/img/newhome/header/redeem.svg`" class="brightness-0" />
            Beneficios
          </a>

          <a href="/revision-tecnica"
            class="rounded-lg flex items-center p-3 gap-3 bg-GRIS_CLARO font-semibold relative">
            <img src="/img/newhome/header/calendar.webp" class="brightness-0" />Calendario Revisión Técnica
          </a>

          <a @click="navigateToRetiraYEntrega"
            class="rounded-lg flex items-center p-3 gap-3 bg-GRIS_CLARO font-semibold relative">
            <img src="/img/newhome/header/delivery_truck_bolt.svg" class="brightness-0"/>
            Retiro y Entrega
          </a>

            <a
              @click="navigateToAsociados"
              class="rounded-lg flex items-center p-3 gap-3 bg-GRIS_CLARO font-semibold relative cursor-pointer"
            >
              <img src="/img/newhome/header/location_away.svg" class="brightness-0" />Asociados LEÓN
            </a>

        </div>
        <hr />
        <div class="flex flex-col gap-3">
          <a href="https://qr.queop.com/a4391284c0d2cbbe4c17f70526c4dc0d1"
            class="rounded-lg flex p-3 gap-3 font-semibold  hover:text-ROJO_LEON">
            <img :src="`/img/newhome/header/psychology_alt.webp`" class="h-[24px]" />
            <p>Sugerencias y Reclamos</p>
          </a>

          <a href="http://boletas.leon.cl" class="rounded-lg flex p-3 gap-3 font-semibold  hover:text-ROJO_LEON">
            <img :src="`/img/newhome/header/description.webp`" class="h-[24px]" />
            <p>Consulta Boletas</p>
          </a>

          <a @click="navigateToTerminos"
            class="rounded-lg flex p-3 gap-3 font-semibold hover:text-ROJO_LEON cursor-pointer">
            <img :src="`/img/newhome/header/contract.webp`" class="h-[24px]" />
            Términos y Condiciones
          </a>

          <NuxtLink to="/postulaciones"
            class="rounded-lg flex p-3 gap-3 border self-start text-ROJO_LEON border-ROJO_LEON font-semibold hover:text-ROJO_LEON">
            <img :src="`/img/newhome/header/handshake.webp`" class="h-[24px]" />
            Trabaja con nosotros
          </NuxtLink>
        </div>
      </div>

      <div class="w-full top-0 md:top-[unset] fixed h-screen md:h-auto bg-white transition-all overflow-y-auto md:absolute max-w-[1300px] z-[300] md:left-1/2 md:-translate-x-1/2 md:rounded-b-xl"
        :class="{
          'left-0': showMenuProducts && !es_desktop,
          'left-full': !showMenuProducts && !es_desktop,
          'hidden': !showMenuProducts && es_desktop,
          'block': showMenuProducts && es_desktop,
        }">
        <div
          class="flex justify-between items-center md:justify-center p-3 text-white font-semibold bg-white md:bg-GRIS_LEON">
          <p class="hidden md:flex md:flex-row items-center gap-4 text-white productos-button"><img
              src="/img/newhome/header/directions_car.svg" />Productos y Servicios</p>
          <img src="/img/newhome/header/red-arrow-back.webp" class="md:hidden"
            @click="showMenuProducts = !showMenuProducts" />
          <div class="md:hidden bg-ROJO_LEON rounded-full py-3 px-2 cursor-pointer transition" @click="closeAllMenus">
            <div class="bg-white h-1 w-4 rotate-45 relative top-[2px]"></div>
            <div class="bg-white h-1 w-4 -rotate-45 relative -top-[2px]"></div>
          </div>
        </div>
        <div class="bg-white p-5 md:p-10 rounded-b-xl">
          <div class="max-w-[1100px] w-full mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 items-start">
            <div class="grid md:grid-cols-3 gap-5 col-span-2">
              <template v-for="link in links" :key="link.text">
                <NuxtLink v-if="link.isInternal" :to="link.link"
                  class="rounded-lg flex p-3 gap-3 bg-GRIS_CLARO font-semibold transition-all duration-300 hover:bg-ROJO_LEON hover:text-white group">
                  <img :src="`/img/newhome/header/${link.icon}.webp`"
                    class="h-[24px] transition-all duration-300 group-hover:brightness-0 group-hover:invert" />
                  {{ link.text }}
                </NuxtLink>

                <a v-else :href="link.link"
                  class="rounded-lg flex p-3 gap-3 bg-GRIS_CLARO font-semibold transition-all duration-300 hover:bg-ROJO_LEON hover:text-white group">
                  <img :src="`/img/newhome/header/${link.icon}.webp`"
                    class="h-[24px] transition-all duration-300 group-hover:brightness-0 group-hover:invert" />
                  {{ link.text }}
                </a>
              </template>
            </div>

            <div class="col-span-1 hidden md:block">
              <div class="flex flex-col w-full aspect-auto md:h-[22rem] rounded-lg px-2">
                <CarruselPromocional :imagenesPromocionales="imagenesPromocionales" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from "vuex";
import { useRouter } from 'vue-router'
import { NEGOCIOS } from "~/constants/negocios";
import { aliasSistemas } from '~/constants/aliasSistemas';
import CarruselPromocional from '~/components/Carruseles/CarruselPromocional.vue';

const modo_sistema = useState('modo_sistema');
const { products, setShoppingStep, getProducts, verifyCartTimestamp} = useCartBridge();
const store = useStore();
const route = useRoute()
const router = useRouter()
const config = useRuntimeConfig();

const debug = {
  enabled: config.public.modo === 'DEV',

  log(...args) {
    if (this.enabled) console.log(...args);
  },
  error(...args) {
    if (this.enabled) console.error(...args);
  },
};

// Fetch de imágenes promocionales
const alias = computed(() => aliasSistemas[modo_sistema.value]);

const { data: imagenesPromoResponse } = await useFetch('/api/recursos', {
  query: { action: 'getImagenesPromocionales', alias: alias.value },
  server: true,
  lazy: true,
  watch: [alias],
});

const imagenesPromocionales = computed(() => {

  // Fallback por defecto
  const fallbackData = {
      desktop: [{
      tipo: 'imagen',
      clase_contenedor: "rounded-lg overflow-hidden min-w-[300px] max-w-[450px]",
      imagen_clase: "w-full h-full object-cover rounded-lg",
      imagen: "/img/home/ofertas-destacadas/promos-del-mes-ruleta.png",
      alt: "promocion default",
      enlace: null
    }],
    mobile: [{
      tipo: 'imagen',
      clase_contenedor: "rounded-lg overflow-hidden min-w-[300px] max-w-[450px]",
      imagen_clase: "w-full h-full object-cover rounded-lg",
      imagen: "/img/home/ofertas-destacadas/promos-del-mes-ruleta.png",
      alt: "promocion default",
      enlace: null
    }]
  };

  /*
  debug.log('[imagenesPromocionales] Evaluando:', {
    isServer: import.meta.server,  // ← Cambio aquí
    hasResponse: !!imagenesPromoResponse.value,
    responseStatus: imagenesPromoResponse.value?.status,
    responseData: imagenesPromoResponse.value?.data
  });
  */

  // Validar respuesta del API
  if (!imagenesPromoResponse.value || imagenesPromoResponse.value?.status !== 'success' || !imagenesPromoResponse.value?.data) {
    //debug.log('[imagenesPromocionales] Usando FALLBACK');
    return fallbackData;
  }

  //debug.log('[imagenesPromocionales] Usando datos API');
  const apiData = imagenesPromoResponse.value.data;

  // Mapear desktop
  const desktopData = apiData.desktop?.length > 0
    ? apiData.desktop.map(item => ({
        tipo: 'imagen',
        clase_contenedor: "rounded-lg overflow-hidden min-w-[300px] max-w-[450px]",
        imagen_clase: "w-full h-full object-cover rounded-lg",
        imagen: item.imagen,
        alt: item.alt || "promoción",
        enlace: item.enlace || null
      }))
    : fallbackData.desktop;

  // Mapear mobile
  const mobileData = apiData.mobile?.length > 0
    ? apiData.mobile.map(item => ({
        tipo: 'imagen',
        clase_contenedor: "rounded-lg overflow-hidden min-w-[300px] max-w-[450px]",
        imagen_clase: "w-full h-full object-cover rounded-lg",
        imagen: item.imagen,
        alt: item.alt || "promoción",
        enlace: item.enlace || null
      }))
    : fallbackData.mobile;

  // Construir objeto final
  const resultado = {
    desktop: desktopData,
    mobile: mobileData
  };

  //debug.log('[imagenesPromocionales] Resultado final:', resultado);

  return resultado;
});

// Computed properties para las condiciones de rutas
const condicion_de_rutas = computed(() => {
  console.log(route.path);
  const esLocal = NEGOCIOS.LOCALES.includes(modo_sistema.value);
  const esRutaValida = modo_sistema.value === NEGOCIOS.HOME || 
    route.path === `/${NEGOCIOS.NEUMATICOS}`      || 
    route.path === `/${NEGOCIOS.ACEITES}`         ||
    route.path === `/${NEGOCIOS.BATERIAS}`        ||     
    route.path === `/${NEGOCIOS.FRENOS}`          || 
    route.path === `/${NEGOCIOS.AFINAMIENTO}`     || 
    route.path === `/${NEGOCIOS.AMORTIGUADORES}`  || 
    route.path === `/${NEGOCIOS.TRENDELANTERO}`   || 
    route.path === `/${NEGOCIOS.ALINEACION}`      || 
    route.path === `/${NEGOCIOS.BALANCEO}`        || 
    route.path === `/${NEGOCIOS.GEOMETRIA}`       || 
    route.path === `/${NEGOCIOS.KILOMETRAJE}`     || 
    route.path === `/${NEGOCIOS.HIGIENIZACION}`   || 
    route.path === `/${NEGOCIOS.FLUIDOS}`         || 
    route.path === `/${NEGOCIOS.ELECTRICO}`       || 
    route.path === `/${NEGOCIOS.ACCESORIOS}`              ||
    route.path === `/${NEGOCIOS.REVISIONTECNICA}`         ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/more`         ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/guide`        ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/tips`         ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/detail`       ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/signal`       ||
    route.path === `/${NEGOCIOS.BATERIAS}/change`         ||
    route.path === `/${NEGOCIOS.BATERIAS}/type`           ||
    route.path === `/${NEGOCIOS.BATERIAS}/concepts`       ||
    route.path === `/${NEGOCIOS.BATERIAS}/mantenimiento`  ||
    route.path === `/boletas` ||
    esLocal

  return esRutaValida && es_desktop.value
})

const carrito_neumaticos = computed(() => {
  let valor = ((route.path === '/' || route.path.startsWith(`/${NEGOCIOS.NEUMATICOS}`)) && countCart.value > 0)
  return valor
})

const carrito_baterias = computed(() => {
  let valor = (route.path.startsWith(`/${NEGOCIOS.BATERIAS}`) && countCart.value > 0)
  return valor
})

// Refs reactivas
const showMenuProducts = ref(false)
const logoUrl = ref('/img/shared/logo-leon.webp')
const showMenuMobile = ref(false)
const duplicatedSlides = ref([])
const es_desktop = ref(true)

const navigateToHome = async (event) => {
  const url = '/'
  
  if (event?.ctrlKey || event?.metaKey) {
    window.open(url, '_blank')
  } else {
    await router.push(url)
  }
}

const navigateToTerminos = async (event) => {
  const url = '/terminos-y-condiciones'
  
  if (event?.ctrlKey || event?.metaKey) {
    window.open(url, '_blank')
  } else {
    await router.push(url)
  }
}

const navigateToBeneficios = async (event) => {
  const url = '/beneficios'
  
  if (event?.ctrlKey || event?.metaKey) {
    window.open(url, '_blank')
  } else {
    await router.push(url)
  }
}

const navigateToRetiraYEntrega = async (event) => {
  const url = '/retiro-y-entrega'
  
  if (event?.ctrlKey || event?.metaKey) {
    window.open(url, '_blank')
  } else {
    await router.push(url)
  }
}

const navigateToNuestrosLocales = async (event) => {
  const url = '/nuestros-locales'
  
  if (event?.ctrlKey || event?.metaKey) {
    window.open(url, '_blank')
  } else {
    await router.push(url)
  }
}

function handleResize() {
  es_desktop.value = window.innerWidth > 768
}

const closeAllMenus = () => {
  showMenuProducts.value = false
  showMenuMobile.value = false
}

const slidesmobile = ref([
  {
    src: '/img/svg_carrusel/frenos.svg',
    alt: 'frenos-icon',
    link: `/${NEGOCIOS.FRENOS}`,
    text: 'Frenos',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/neumatico.svg',
    alt: 'neumaticos-icon',
    link: `/${NEGOCIOS.NEUMATICOS}`,
    text: 'Neumáticos',
    isInternal: true
  },
  {
    src: '/img/svg_carrusel/aceite.svg',
    alt: 'aceites-icon',
    link: `/${NEGOCIOS.ACEITES}`,
    text: 'Cambio de aceite',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/baterias.svg',
    alt: 'baterias-icon',
    link: `/${NEGOCIOS.BATERIAS}`,
    //link: 'https://baterias.leon.cl/',
    text: 'Baterias',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/afinamiento.svg',
    alt: 'afinamiento-icon',
    link: `/${NEGOCIOS.AFINAMIENTO}`,
    text: 'Afinamiento',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/amortiguadores.svg',
    alt: 'amortiguadores-icon',
    link: `/${NEGOCIOS.AMORTIGUADORES}`,
    text: 'Amortiguadores',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/tren_delantero.svg',
    alt: 'tren-delantero-icon',
    link: `/${NEGOCIOS.TRENDELANTERO}`,
    text: 'Tren delantero',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/alineacion.svg',
    alt: 'alineacion-icon',
    link: `/${NEGOCIOS.ALINEACION}`,
    text: 'Alineacion',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/balanceo.svg',
    alt: 'balanceo-icon',
    link: `/${NEGOCIOS.BALANCEO}`,
    text: 'Balanceo',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/geometria.svg',
    alt: 'icono-geometria',
    link: `/${NEGOCIOS.GEOMETRIA}`,
    text: 'Geometría',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/mantencion_km.svg',
    alt: 'mantencion-kilometraje-icon',
    link: `/${NEGOCIOS.KILOMETRAJE}`,
    text: 'Mantención de kilometraje',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/higienizacion.svg',
    alt: 'icono-higienizacion',
    link: `/${NEGOCIOS.HIGIENIZACION}`,
    text: 'Higienización',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/fluidos.svg',
    alt: 'fluidos-icon',
    link: `/${NEGOCIOS.FLUIDOS}`,
    text: 'Fluidos',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/electrico.svg',
    alt: 'icono-electrico',
    link: `/${NEGOCIOS.ELECTRICO}`,
    text: 'Eléctrico',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/accesorios.svg',
    alt: 'accesorios-icon',
    link: `/${NEGOCIOS.ACCESORIOS}`,
    text: 'Accesorios',
    isInternal: false
  },
])

const slidesdesktop = ref([
  {
    src: '/img/svg_carrusel/amortiguadores.svg',
    alt: 'amortiguadores-icon',
    link: `/${NEGOCIOS.AMORTIGUADORES}`,
    text: 'Amortiguadores',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/tren_delantero.svg',
    alt: 'tren-delantero-icon',
    link: `/${NEGOCIOS.TRENDELANTERO}`,
    text: 'Tren delantero',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/alineacion.svg',
    alt: 'alineacion-icon',
    link: `/${NEGOCIOS.ALINEACION}`,
    text: 'Alineacion',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/balanceo.svg',
    alt: 'balanceo-icon',
    link: `/${NEGOCIOS.BALANCEO}`,
    text: 'Balanceo',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/neumatico.svg',
    alt: 'neumaticos-icon',
    link: `/${NEGOCIOS.NEUMATICOS}`,
    text: 'Neumáticos',
    isInternal: true
  },
  {
    src: '/img/svg_carrusel/aceite.svg',
    alt: 'aceites-icon',
    link: `/${NEGOCIOS.ACEITES}`,
    text: 'Cambio de aceite',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/baterias.svg',
    alt: 'baterias-icon',
    link: `/${NEGOCIOS.BATERIAS}`,
    //link: 'https://baterias.leon.cl/',
    text: 'Baterias',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/afinamiento.svg',
    alt: 'afinamiento-icon',
    link: `/${NEGOCIOS.AFINAMIENTO}`,
    text: 'Afinamiento',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/frenos.svg',
    alt: 'frenos-icon',
    link: `/${NEGOCIOS.FRENOS}`,
    text: 'Frenos',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/geometria.svg',
    alt: 'icono-geometria',
    link: `/${NEGOCIOS.GEOMETRIA}`,
    text: 'Geometría',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/higienizacion.svg',
    alt: 'icono-higienizacion',
    link: `/${NEGOCIOS.HIGIENIZACION}`,
    text: 'Higienización',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/fluidos.svg',
    alt: 'fluidos-icon',
    link: `/${NEGOCIOS.FLUIDOS}`,
    text: 'Fluidos',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/mantencion_km.svg',
    alt: 'mantencion-kilometraje-icon',
    link: `/${NEGOCIOS.KILOMETRAJE}`,
    text: 'Mantención de kilometraje',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/electrico.svg',
    alt: 'icono-electrico',
    link: `/${NEGOCIOS.ELECTRICO}`,
    text: 'Eléctrico',
    isInternal: false
  },
  {
    src: '/img/svg_carrusel/accesorios.svg',
    alt: 'accesorios-icon',
    link: `/${NEGOCIOS.ACCESORIOS}`,
    text: 'Accesorios',
    isInternal: false
  },
])

const countCart = computed(() => {
  return products.value.reduce((acc, product) => acc + product.quantity, 0)
})

const fetchLogoStatus = async () => {
  try {
    const response = await $fetch('/api/mantenedores-visuales', {
      query: {
        action: 'countdown',
        alias: config.public.aliasCountdown
      }
    });
    if (response.status === 'success' && response.data) {
      const data = response.data;

      if (data.cyber_activo === 'SI') {
        logoUrl.value = data.url_logo_leon;
      }
    }
  } catch (error) {
    console.error('Error fetching logo status:', error)
  }
};

const updateSlides = () => {
  const isLargeScreen = window.innerWidth >= 768
  const baseSlides = isLargeScreen ? slidesdesktop.value : slidesmobile.value

  const serializedSlides = baseSlides.map((slide) => ({
    src: slide.src,
    alt: slide.alt,
    link: slide.link,
    text: slide.text,
    isInternal: slide.isInternal
  }))

  duplicatedSlides.value = [...serializedSlides, ...serializedSlides]
}

const openTelephonellamanosv2 = () => {
  const popupLocales = document.getElementById('popupLocales')
  if (popupLocales) {
    popupLocales.classList.remove('hidden')
    popupLocales.classList.add('flex')
  }
  document.body.style.overflow = 'hidden'
}

const resetShoppingStep = () => {
  setShoppingStep(0)
}

const navigateToAsociados = async (event) => {
  if (event) {
    event.preventDefault();
  }

  closeAllMenus();
  await navigateTo('/asociados');
};


const links = [
  { 
    text: 'Neumáticos', 
    link: `/${NEGOCIOS.NEUMATICOS}`, 
    icon: 'llanta', isInternal: true 
  },
  { 
    text: 'Amortiguadores', 
    link: `/${NEGOCIOS.AMORTIGUADORES}`,
    icon: 'amortiguadores', isInternal: false 
  },
  { 
    text: 'Mantención de KM', 
    link: `/${NEGOCIOS.KILOMETRAJE}`,
    icon: 'mantencion-kilometraje', isInternal: false 
  },
  { 
    text: 'Frenos', 
    link: `/${NEGOCIOS.FRENOS}`,
    icon: 'frenos', isInternal: false 
  },
  { 
    text: 'Tren delantero', 
    link: `/${NEGOCIOS.TRENDELANTERO}`,
    icon: 'tren-delantero', isInternal: false 
  },
  { 
    text: 'Higienización', 
    link: `/${NEGOCIOS.HIGIENIZACION}`,
    icon: 'higienizacion', isInternal: false 
  },
  { 
    text: 'Cambio de aceite', 
    link: `/${NEGOCIOS.ACEITES}`,
    icon: 'lubricante', isInternal: false 
  },
  { 
    text: 'Alineación', 
    link: `/${NEGOCIOS.ALINEACION}`,
    icon: 'alineacion', isInternal: false 
  },
  { 
    text: 'Fluidos', 
    link: `/${NEGOCIOS.FLUIDOS}`,
    icon: 'fluidos', isInternal: false 
  },
  { 
    text: 'Baterías', 
    link: `/${NEGOCIOS.BATERIAS}`,
    //link: 'https://baterias.leon.cl/',
    icon: 'baterias', isInternal: false 
  },
  { 
    text: 'Balanceo', 
    link: `/${NEGOCIOS.BALANCEO}`,
    icon: 'balanceo', isInternal: false 
  },
  { 
    text: 'Eléctrico', 
    link: `/${NEGOCIOS.ELECTRICO}`,
    icon: 'electrico', isInternal: false 
  },
  { 
    text: 'Afinamiento', 
    link: `/${NEGOCIOS.AFINAMIENTO}`,
    icon: 'afinamiento', isInternal: false 
  },
  { 
    text: 'Geometría', 
    link: `/${NEGOCIOS.GEOMETRIA}`,
    icon: 'geometria', isInternal: false 
  },
  { 
    text: 'Accesorios', 
    link: `/${NEGOCIOS.ACCESORIOS}`,
    icon: 'accesorios', isInternal: false 
  },
]

const handleScroll = () => {
  if (showMenuProducts.value) {
    showMenuProducts.value = false
  }
}

onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize)
  window.addEventListener('scroll', handleScroll)
  fetchLogoStatus()
  getProducts()

  verifyCartTimestamp()
  store.commit('plpModule/verifySearchVehicleTimeStamp')
  updateSlides()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', handleScroll)
  document.body.classList.remove('popup-active')
})

watch(showMenuMobile, (newValue) => {
  if (newValue) {
    document.body.classList.add('popup-active')
  } else {
    document.body.classList.remove('popup-active')
  }
})

watch(() => route.path, () => {
  showMenuProducts.value = false
  showMenuMobile.value = false
  document.body.classList.remove('popup-active')
})
</script>

<style scoped>
.forzarpadding{
  padding: 0.2rem 0.4rem;
}
/* Hover para los enlaces del menú principal en la barra roja */
.menu-link {
  transition: background-color 0.3s ease;
  border-radius: 4px;
  padding: 0.5rem 0.5rem;
}

.menu-link:hover {
  background-color: #8B1A17;
  /* Rojo más oscuro */
}

/* --- Estilos originales del componente --- */
.dc_ajuste {
  display: flex;
  flex-direction: column;
}

.dc_ajuste:hover .carousel-text {
  color: #bd2520;
}

.dc_ajuste:hover img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(2551%) hue-rotate(350deg) brightness(84%) contrast(90%);
  max-height: 100%;
}

.modificar {
  padding: 1px 40px 1px 40px !important;
  max-height: 80px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide .item-image {
  max-width: 36px !important;
  max-height: 60%;
  margin-right: 2px;
}

.swiper-slide {
  width: auto !important;
  margin-right: 30px !important;
}

.carousel-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-slide img {
  max-width: 50px;
  margin-right: 10px;
}

.carousel-text {
  font-size: 1rem;
  color: #333;
  white-space: nowrap;
}

#sideMenu.open {
  width: 100%;
}

#header-menu-hamburger {
  transition: background-color 0.3s ease-in-out;
}

#header-menu-hamburger.open {
  background-color: transparent;
}

#closeMenu {
  transition: background-color 0.3s ease-in-out;
}

#closeMenu.open {
  background-color: transparent;
}

.item-image {
  width: 75px !important;
  height: auto !important;
  object-fit: contain !important;
}

:global(body.popup-active) {
  overflow: hidden !important;
  height: 100vh;
}

@media (max-width: 780px) {
  .modificar {
    padding: 9px 10px 9px 10px !important;
  }

  .swiper-slide {
    margin-right: 15px !important;
  }

  .carousel-text {
    font-size: 15px !important;
  }

  #header-menu-hamburger {
    position: relative;
    width: 30px;
    height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
  }

  #header-menu-hamburger div {
    width: 100%;
    height: 4px;
    background-color: white;
    transition: transform 0.3s ease, opacity 0.4s ease, background-color 0.4s ease;
  }

  #header-menu-hamburger.active div:nth-child(1) {
    transform: rotate(45deg) translate(7px, 6px);
  }

  #header-menu-hamburger.active div:nth-child(2) {
    opacity: 0;
  }

  #header-menu-hamburger.active div:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }

  #header-menu-hamburger:not(.active) div:nth-child(1),
  #header-menu-hamburger:not(.active) div:nth-child(3) {
    transform: rotate(0deg) translate(0, 0);
  }

  #header-menu-hamburger:not(.active) div:nth-child(2) {
    opacity: 1;
  }

  #header-menu-hamburger.active {
    animation: spinX 0.5s forwards;
  }

  #header-menu-hamburger:not(.active) {
    animation: spinBack 0.5s forwards;
  }

  @keyframes spinX {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinBack {
    0% {
      transform: rotate(360deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }
}
</style>